import classNames from "classnames";
import style from "./form.module.scss";
import { Icon } from "@/elements-react/fix-icon";
import successCircle from "@/assets/form/successCircle.svg";
import clockIcon from "@/assets/clock.svg";
import messageCloudIcon from "@/assets/messageCloud.svg";
import mailIcon from "@/assets/form/mail.svg";
import React from "preact/compat";
import { useServices } from "@/services-context";

export interface FormSuccessStateProps {
  onClick: () => void;
}

export const FormSuccessState: React.FC<FormSuccessStateProps> = ({ onClick }) => {
  const { customerChannel } = useServices();

  return (
    <div className={classNames(style.successGroup)}>
      <div className={classNames(style.topGroup)}>
        <div className={classNames(style.iconBox)}>
          <div>
            <Icon src={successCircle} height={48} width={48} className={classNames(style.icon)} />
          </div>
        </div>
        <div>
          <p className={classNames(style.title)}>Request sent!</p>
          <p className={classNames(style.description)}>We'll find the best spare part options for you and get back shortly</p>
        </div>
      </div>
      <div className={classNames(style.line)} />
      <div className={classNames(style.bottomGroup)}>
        <p className={classNames(style.titleTwo)}>What happens next:</p>
        <div className={classNames(style.itemsGroup)}>
          <div className={classNames(style.itemContainer)}>
            <div className={classNames(style.itemIconBox)}>
              <Icon src={clockIcon} className={classNames(style.itemIcon)} width={16} height={16} />
            </div>
            <span>We will consider your appeal shortly</span>
          </div>
          <div className={classNames(style.itemContainer)}>
            <div className={classNames(style.itemIconBox)}>
              <Icon src={messageCloudIcon} className={classNames(style.itemIcon)} width={16} height={16} />
            </div>
            <span>Our specialist will select the best options & prices</span>
          </div>
          <div className={classNames(style.itemContainer)}>
            <div className={classNames(style.itemIconBox)}>
              <Icon src={mailIcon} className={classNames(style.itemIcon)} width={16} height={16} />
            </div>
            <span>We'll contact you at {customerChannel.contactEmail}</span>
          </div>
        </div>
      </div>
      <div className={classNames(style.link)} onClick={() => onClick()}>
        Submit another request
      </div>
    </div>
  );
};
